import * as BABYLON from "babylonjs";
import { CoordUtils } from "../core/coordUtils";
import { VectorUtils } from "../core/vectorUtils";
import { Country } from "../model/country";

export class CountryMesh extends BABYLON.Mesh {
    constructor(scene: BABYLON.Scene, country: Country) {
        super(country.isoCode, scene);

        let vertexData = this.generateVertexData(country);
        vertexData.applyToMesh(this);

        let material = new BABYLON.ShaderMaterial(`${name}Mat`, scene, "./assets/earth/shaders/country",
        {
            attributes: ["position", "normal", "uv"],
            uniforms: ["world", "worldViewProjection", "cameraPosition", "lightPosition"]
        });

        this.material = material;

        this.registerBeforeRender(it => { it.getEngine().setDepthBuffer(false); it.getEngine().setAlphaMode(BABYLON.Engine.ALPHA_MAXIMIZED); });
        this.registerAfterRender(it => {it.getEngine().setDepthBuffer(true); it.getEngine().setAlphaMode(BABYLON.Engine.ALPHA_DISABLE); });
    }

    private generateVertexData(country: Country): BABYLON.VertexData {
        let vertices = country.meshData.points.map(CoordUtils.geoToBabylon);
        let normals = vertices.map(it => BABYLON.Vector3.Normalize(it));
        let vertexData = new BABYLON.VertexData();
        vertexData.positions = VectorUtils.toNumberArray(vertices);
        vertexData.normals = VectorUtils.toNumberArray(normals);
        vertexData.indices = country.meshData.indices;
        return vertexData;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/countryMesh.ts